
import AdminLayout from "@/components/admin/AdminLayout";
import NotificationAnalyticsDashboard from "@/components/admin/notifications/NotificationAnalyticsDashboard";

const AdminNotificationAnalytics = () => {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Notification Analytics</h1>
          <p className="text-muted-foreground mt-1">
            Monitor notification performance, delivery rates, and user engagement
          </p>
        </div>

        <NotificationAnalyticsDashboard />
      </div>
    </AdminLayout>
  );
};

export default AdminNotificationAnalytics;
